import gql from 'graphql-tag';
import moveIqCompanyFragment from './moveiq-company';

const NAME = 'offersOutput';
const FRAGMENT = `
  fragment ${NAME} on GenerateMoveIqOffersOutput {
    averagePrice
    averagePriceWithPacking
    averageValueScore
    id
    offerGroups {
      company {
        ...${moveIqCompanyFragment.name}
      }
      offers {
        date
        id
        price
        priceWithPacking
        valueScore
        valueScoreWithPacking
        valueTier
        valueTierWithPacking
      }
    }
    unqualifiedCompanies {
      ...${moveIqCompanyFragment.name}
    }
  }
  ${moveIqCompanyFragment.fragment}
`;

export default {
  fragment: FRAGMENT,
  name: NAME,
  gql: gql`
    ${FRAGMENT}
  `,
};
